const brushes = document.querySelectorAll('.brush');

const observer = new IntersectionObserver(
  (entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = Number(el.dataset.delay) || 0;

        setTimeout(() => {
          el.classList.add('is-active');
        }, delay);

        obs.unobserve(el);
      }
    });
  },
  {
    root: null,
    threshold: 0,
    rootMargin: "-50% 0px -50% 0px"
  }
);

brushes.forEach(el => observer.observe(el));